<template>
    <div class="recharge_left capital_first" v-if="lifetimeTradeStatus == 1">
        <el-card class="box-card common-bg" shadow="never">
            <div slot="header" class="clearfix">
                <el-col :span="12">
                    <h3>终生奖励<span class="text_red_color">一次持仓 终生受益   
                    </span></h3>
                </el-col>
            </div>
            <el-tabs>
                <el-tab-pane id="isFromCoupon1">
                    <h4 slot="label"> 终生奖励</h4>
                    <el-card class="box-card">
                        <div slot="header" class="clearfix">
                        <el-row>
                            <el-col :span="5" style="text-align: center;line-height: 30px" class="common_border">
                                <h3>本月奖励 </h3>
                                <p class="text_red_color" style="font-size: 16px;">{{ user_lifetime_reward_balance }}</p>
                            </el-col>
                            <el-col :span="5" style="text-align: center;line-height: 30px;margin-left:20px;" v-if="user_lifetime_reward_balance>0" class="common_border">
                                <h5 style="font-weight: 200;margin-bottom: 3px;">领取倒计时 </h5>
                                <p class="red" style="font-size: 13px;margin-bottom: 12px;" >
                                    {{days}}天{{hours}}小时{{minutes}}分{{seconds}}秒
                                </p>
                                    <el-button type="primary" class="button_blue_color" @click="lifetimeRewardTransferState = true; lifetimeRewardAmount=user_lifetime_reward_balance">点击领取
                                    </el-button>
                                </el-col>
                        </el-row>
                    </div>
                        <div slot="header" class="clearfix">
                            <el-row style="padding-top:18px">
                                <el-col :span="5" style="text-align: center;line-height: 30px;" class="common_border">
                                    <h3>累计领取
                                    </h3>
                                    <p class="text_red_color">{{  user_cumulative_collection }}</p>
                                </el-col>
                                <el-col :span="5" style="text-align: center;line-height: 30px;margin-left:20px;" class="common_border">
                                    <h3 >累计过期
                                    </h3>
                                    <p class="text_red_color">{{ user_cumulative_expire_amount }}</p>
                                </el-col>
                                <el-col :span="5" style="text-align: center;line-height: 30px;margin-left:20px;" class="common_border">
                                    <h3>累计奖励
                                    </h3>
                                    <p class="text_red_color" >{{ user_cumulative_lifetime_reward }}</p>
                                </el-col>
                               
                            </el-row>
                        </div>
                        <el-tabs stretch>
                            <div style="text-align: justify;">
                                <p v-html="lifetimeRewardDesc"></p>
                            </div>
                        </el-tabs>
    
                    </el-card>
                </el-tab-pane>
                <el-tab-pane id="isFromCoupon2">
                    <h4 slot="label"> 账单</h4>
                    <el-card>
                        <el-form :inline="true" size="mini">
                            <el-form-item label="日期">
                                <el-date-picker v-model="lifetimeRewardDetails.date" type="daterange" value-format="yyyy-MM-dd" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
                                </el-date-picker>
                            </el-form-item>
                            <el-form-item>
                                <el-button type="primary" class="button_blue_color" @click="getLifetimeRewardDetails">检索</el-button>
                            </el-form-item>
                        </el-form>
                        <el-table :data="lifetimeRewardDetails.data" size="mini" stripe style="width: 100%">
                            <el-table-column  align="center" label="类型" width="100">
                                <template slot-scope="scope">
              <span v-if="scope.row.type == 1"
                >终生奖励</span
              >
              <span v-if="scope.row.type == 2">终生奖励转出</span>
              <span v-if="scope.row.type == 3">终生奖励作废</span>
            </template>
                            </el-table-column>
                            <!-- <el-table-column prop="pure_recharge_amount" align="center" label="净充值额">
                            </el-table-column>
                            <el-table-column prop="total_buy_amount" align="center" label="总买入额">
                            </el-table-column> -->
                            <el-table-column prop="amount" align="center" label="生金额">
                            </el-table-column>
                            <el-table-column prop="lifetime_reward_balance" align="center" label="余额">
                            </el-table-column>
                            <!-- <el-table-column prop="accumulated_total_reward_amount" align="center" label="积累奖励">
                            </el-table-column> -->
                            <el-table-column prop="time" align="center" label="创建时间">
                            </el-table-column>
                        </el-table>
                        <div class="changePage" style="padding-top: 15px;">
                            <el-button type="primary" class="button_blue_color" icon="el-icon-arrow-left" @click="prevLifetimeReward" size="mini">上一页</el-button>
                            <el-button type="primary" class="button_blue_color" icon="el-icon-arrow-right" @click="nextLifetimeReward" size="mini" style="float: right">
                                下一页
                            </el-button>
                        </div>
                    </el-card>
                    <div class="text_red_color" style="margin-top: 25px; margin-bottom: 25px; font-weight: bold;text-align: center;">
                        只显示最近12个月记录
                    </div>
                </el-tab-pane>
            </el-tabs>
    
        </el-card>
    
        <el-dialog class="lifetime_reward_popup" title="本月奖励" :visible.sync="lifetimeRewardTransferState">
            <el-form ref="form" label-width="100px" size="small">
                <el-form-item>
                    <h4 slot="label">可领取奖励:</h4>
                    <p style="margin-right: 3px;">{{ user_lifetime_reward_balance }}元</p>
                </el-form-item>
                <!-- <el-form-item>
                    <el-input  oninput="
        if (value.startsWith('.')) value = '0' + value; 
        value = value.replace(/[^0-9.]/g, '')           
                     .replace(/(\..*?)\..*/g, '$1')     
                     .replace(/^(\d+\.?\d{0,2}).*/, '$1'); "
                    v-model="lifetimeRewardAmount" placeholder=""></el-input>
                </el-form-item> -->
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="lifetimeRewardTransferState = false">取消</el-button>
                <el-button type="primary" class="button_blue_color" @click="lifetimeRewardTransfer">领取</el-button>
            </div>
        </el-dialog>
    </div>
    </template>
    
      
    <script>
    export default {
        name: "lifetime_reward",
        data() {
            return {
                days: 0,
                hours: 0,
                minutes: 0,
                seconds: 0,
                user_cumulative_lifetime_reward: 0,
                user_cumulative_expire_amount: 0,
                user_lifetime_reward_balance: 0,
                user_cumulative_collection: 0,
                lifetimeRewardAmount: null,
                lifetimeRewardTransferState: false,
                lifetimeRewardDesc: '',
                lifetimeTradeStatus: 0,
                lifetimeRewardDetails: {
                    date: [],
                    data: [],
                    page: 1,
                    num: 10
                }
            }
        },
        computed: {},
        methods: {
        getEndOfMonthTime() {
            let that = this;
            const now = new Date();
            const endOfMonth = new Date(now.getFullYear(), now.getMonth() + 1, 0);
            const diffInSeconds = Math.floor((endOfMonth - now) / 1000);
            that.days = Math.floor(diffInSeconds / (24 * 3600));
            that.hours = Math.floor((diffInSeconds % (24 * 3600)) / 3600);
            that.minutes = Math.floor((diffInSeconds % 3600) / 60);
            that.seconds = diffInSeconds % 60;
        },
        getLifetimeRewardDetails() {
            let that = this;

            const requestData = {
                nozzle: "lifetime_reward",
                token: sessionStorage.getItem("token"),
                action: "lifetime_reward_log",
                page: that.lifetimeRewardDetails.page,
                num: that.lifetimeRewardDetails.num,
            };

            if (that.lifetimeRewardDetails.date && that.lifetimeRewardDetails.date.length === 2) {
                requestData.start = that.lifetimeRewardDetails.date[0];
                requestData.end = that.lifetimeRewardDetails.date[1];
            }

            that
                .$http({
                    url: "/",
                    method: "post",
                    data: requestData
                })
                .then(function (res) {
                    if (res.data.code == 1) {
                        let resData = res.data;
                        that.lifetimeRewardDetails.data = resData.data;
                    } else if (res.data.code == 0 || res.data.code == -1) {
                        that.$message.error(res.data.msg);
                    }
                });
        },
        getUserinfo() {
            let that = this;
            that.$http({
                    url: "/",
                    method: "post",
                    data: {
                        nozzle: "user",
                        token: sessionStorage.getItem("token")
                    }
                })
                .then(function (res) {
                    if (res.data.code == 1) {
                        that.user_lifetime_reward_balance = Number(res.data.data.lifetime_reward_balance).toFixed(2);
                        that.user_cumulative_expire_amount = Number(res.data.data.cumulative_lifetime_expire_amount).toFixed(2);
                        that.user_cumulative_collection = Number(res.data.data.cumulative_lifetime_reward_amount).toFixed(2);
                        that.user_cumulative_lifetime_reward = Number(Number(res.data.data.cumulative_lifetime_expire_amount) + Number(res.data.data.cumulative_lifetime_reward_amount)).toFixed(2);
                        that.lifetimeRewardDesc = res.data.data.lifetime_reward_description;
                        that.lifetimeTradeStatus = res.data.data.lifetime_reward;
                    } else if (res.data.code == 0 || res.data.code == -1) {
                        that.$message.error(res.data.msg);
                    }
                });
        },
        prevLifetimeReward() {
            let page = this.lifetimeRewardDetails.page;
            if (page == 1) {
                this.$message({
                    message: '已经是第一页',
                    type: 'warning'
                });
            } else {
                this.lifetimeRewardDetails.page = page - 1;
                this.getLifetimeRewardDetails();
            }
        },
        nextLifetimeReward() {
            let page = this.lifetimeRewardDetails.page;
            
            if (this.lifetimeRewardDetails.data.length < this.lifetimeRewardDetails.num) {
                this.$message({
                    message: '已经是最后一页',
                    type: 'warning'
                });
            } else {
                this.lifetimeRewardDetails.page = page + 1;
                this.getLifetimeRewardDetails();
            }
        },
        lifetimeRewardTransfer() {
            let that = this;
            let money = that.lifetimeRewardAmount;
            that
                .$http({
                    url: "/",
                    method: "post",
                    data: {
                        nozzle: "lifetime_reward",
                        token: sessionStorage.getItem("token"),
                        action: 'lifetime_reward_withdraw',
                        amount: money,
                    }
                })
                .then(function (res) {
                    if (res.data.code == 1) {
                        that.lifetimeRewardTransferState = false;
                        that.$message({
                            message: res.data.msg,
                            type: 'success',
                            onClose: function () {
                                // that.mainMethod();
                            }
                        });
                        that.mainMethod();
                    } else if (res.data.code == 0 || res.data.code == -1) {
                        that.$message.error(res.data.msg);
                    }
                });
        },
        mainMethod() {
            this.getLifetimeRewardDetails();
            this.getUserinfo();
        },
    },
    mounted() {
        this.getEndOfMonthTime(); // Initial call
        this.timerInterval = setInterval(() => {this.getEndOfMonthTime(), 1000}); // Update every second
        this.getLifetimeRewardDetails();
        this.getUserinfo();
    },
}
</script>
<style scope>
    .lifetime_reward_popup .el-dialog {
        width: 20% !important;
    }
    .lifetime_button{
        border:1px solid #e3e3e3!important; 
        border-radius: 20px !important; 
        padding:15px;
    }
    .dialog-footer {
        display: flex;
        justify-content: center;
    }
    /deep/ .common_border1{
   padding:15px !important;
  margin-bottom:20px !important;
}
</style>
    


// WEBPACK FOOTER //
// src/components/lifetime_reward.vue